<template>
  <div
    class="grid auto-rows-fr gap-4"
    :class="{
      'grid-cols-[repeat(auto-fill,_minmax(10rem,_1fr))]':
        size === 'extra-small',
      'grid-cols-[repeat(auto-fill,_minmax(12rem,_1fr))]': size === 'small',
      'grid-cols-[repeat(auto-fill,_minmax(14rem,_1fr))]': size === 'medium',
      'grid-cols-[repeat(auto-fill,_minmax(18rem,_1fr))]': size === 'large'
    }"
  >
    <label
      v-for="option in options"
      :key="option[trackBy]"
      :data-tint="tinted ? option.color : undefined"
      class="squircle-lg relative block overflow-hidden rounded-lg border select-none"
      :class="{
        'bg-white':
          !colorfull &&
          localModelValue !== option[trackBy] &&
          !disabled &&
          !option.disabled,
        'bg-primary-50':
          colorfull &&
          localModelValue !== option[trackBy] &&
          !disabled &&
          !option.disabled,
        'border-primary bg-primary-50':
          !colorfull &&
          localModelValue == option[trackBy] &&
          !disabled &&
          !option.disabled,
        'border-primary bg-primary text-contrast-primary color-contrast-primary':
          colorfull &&
          localModelValue == option[trackBy] &&
          !disabled &&
          !option.disabled,
        'p-1': !compact && size === 'extra-small',
        'p-2': compact || size === 'small',
        'p-3': !compact && ['medium', 'large'].includes(size),
        'cursor-pointer': !disabled && !option.disabled,
        'cursor-not-allowed bg-gray-50': disabled || option.disabled
      }"
    >
      <div
        v-if="option.icon"
        class="absolute right-2 opacity-50"
        :class="{
          'text-primary-500':
            (!colorfull && localModelValue == option[trackBy]) ||
            (!colorfull && localModelValue !== option[trackBy]) ||
            (colorfull && localModelValue !== option[trackBy]),
          'text-primary-50': colorfull && localModelValue == option[trackBy],

          'bottom-2': option?.description?.length,
          'inset-y-0 flex items-center': !option?.description?.length
        }"
      >
        <FontAwesomeIcon
          :icon="
            Array.isArray(option.icon) ? option.icon : ['fal', option.icon]
          "
          :size="['medium', 'large'].includes(size) ? '2x' : 'lg'"
          fixed-width
        />
      </div>
      <div class="flex h-full flex-row items-center gap-2">
        <input
          v-model="localModelValue"
          type="radio"
          :value="option[trackBy]"
          :disabled="disabled || option.disabled"
          class="bg-white outline-none focus:ring-0 focus:ring-offset-0 active:ring-0 active:ring-offset-0"
          :class="{
            'accent-primary border-primary': !colorfull,
            'accent-contrast-primary border-contrast-primary': colorfull,
            hidden: hideBullet
          }"
          :data-testid="`radio-${option[trackBy]}`"
        />
        <div class="flex flex-col">
          <h3
            class="leading-tight font-semibold"
            :class="{
              'text-base': !compact && ['medium', 'large'].includes(size),
              'text-sm': compact || size === 'small',
              'text-xs': !compact && size === 'extra-small'
            }"
          >
            {{ option[attributeLabel][$i18n.locale] ?? option[attributeLabel] }}
          </h3>
          <p
            v-if="option.sub_label"
            class="text-xs text-gray-500"
            :class="{
              'text-gray-400': ['extra-small', 'small'].includes(size),
              'text-gray-500': ['medium', 'large'].includes(size)
            }"
          >
            {{ option.sub_label }}
          </p>
          <p class="text-xs empty:hidden">{{ option.description }}</p>
        </div>
      </div>
    </label>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
  name: 'RadioCardComponent',
  components: { FontAwesomeIcon },
  props: {
    modelValue: {
      type: [String, Number],
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    trackBy: {
      type: String,
      required: false,
      default: 'value'
    },
    attributeLabel: {
      type: String,
      required: false,
      default: 'label'
    },
    tinted: {
      type: Boolean,
      required: false,
      default: false
    },
    colorfull: {
      type: Boolean,
      required: false,
      default: false
    },
    size: {
      type: String,
      required: false,
      default: 'medium'
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    hideBullet: {
      type: Boolean,
      required: false,
      default: false
    },
    compact: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['update:modelValue'],
  computed: {
    localModelValue: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      }
    }
  }
}
</script>

<style scoped></style>
